import Request from "@/request/base"
import configBaseUrl from "@/config/baseUrl"
import appInfor from "@src/config/appInfor"
import localStorageService from "@src/utils/localStorage"
import storageKeys from "@src/config/storageKeys"

export default class XmBaseRequest extends Request {
  constructor({ env, appName, xmBaseUrl }) {
    const baseURL = xmBaseUrl || configBaseUrl[env].VUE_APP_APISURVEYBASEURL
    const Authorization = appInfor[appName].appId
    let appBaseInfo = localStorageService.getItem(storageKeys.VOCUST_APP_BASE_ID.key)

    super({
      baseURL,
      headers: {
        Authorization,
        token: appBaseInfo && appBaseInfo.token
      }
    })
  }
}
